import React from "react";
import {getDisplayName, hoistNonReactStatics} from "@core-ui/utility";
import {useLocalize} from "./useLocalize";
import {LocalizeProps} from "./types";

export function withLocalize<Props extends LocalizeProps = LocalizeProps>(
  Component: React.ComponentType<Props>
): React.ComponentType<Omit<Props, keyof LocalizeProps>> {
  const WithLocalize = (
    props: Omit<Props, keyof LocalizeProps>
  ): JSX.Element => {
    const localization = useLocalize();
    return <Component {...(props as Props)} {...localization} />;
  };
  WithLocalize.displayName = getDisplayName(Component);
  return hoistNonReactStatics(WithLocalize, Component);
}
